import { Button } from '@strata/react-buttons';
import { Form, Formik } from 'formik';

import { CapturedDataListener } from 'components/intakeForm/CapturedDataListener';
import { useInputFocusRef } from 'components/intakeForm/FormHelpers';
import { type IntakeFormSectionProps } from 'components/intakeForm/IntakeFormSectionProps';
import { PrescriberInputs } from 'components/intakeForm/PrescriberInputs';
import { useAppDispatch, useAppSelector } from 'store';
import { FormSections, IntakeFormSectionSchemas } from 'store/intakeForm/intakeFormSchema';
import { updateCapturedData } from 'store/intakeForm/intakeFormSlice';
import { goToNextSection } from 'store/intakeForm/intakeFormThunks';

const Section = FormSections.PRESCRIBER;

export const Prescriber = ({ isOpen }: IntakeFormSectionProps) => {
    const dispatch = useAppDispatch();
    const { capturedData, activeSection } = useAppSelector((state) => state.intakeForm);

    const prescriberNpiRef = useInputFocusRef(isOpen, activeSection, Section);

    return (
        <Formik
            initialValues={capturedData[Section]}
            enableReinitialize
            validateOnMount
            validationSchema={IntakeFormSectionSchemas[Section]}
            onSubmit={(values) => {
                dispatch(updateCapturedData({ [Section]: values }));
                dispatch(goToNextSection(Section));
            }}
        >
            {(formik) => (
                <Form className="sds_intake-form-section" style={{ maxWidth: '630px' }}>
                    {formik.values.prescriberVerified != null && (
                        <CapturedDataListener section={Section} isOpen={isOpen} />
                    )}
                    <PrescriberInputs prescriberNpiRef={prescriberNpiRef} />
                    <Button
                        intent={Button.Intent.PRIMARY}
                        id="prescriber-continue-button"
                        label="Continue"
                        type="submit"
                        disabled={!formik.isValid}
                    />
                </Form>
            )}
        </Formik>
    );
};
